// extracted by mini-css-extract-plugin
export default {"container":"TransactionPage_container__Lb6ND"};